import { defineColumns } from '@juvare/platform-shared/features/storage';
import { zodKnownFieldDefaultValidation } from '@juvare/platform-shared/features/validation';
import { z } from 'zod';
export const badgeHistoryActions = [
    'badgeCreated',
    'accountBadgeIssued',
    'accountBadgeNotificationSent',
    'accountBadgePrinted',
    'accountBadgeProcessed',
    'accountBadgeDistributed',
    'accountBadgeRevoked',
    'accountBadgeReissued',
    'accountBadgeDistributionStatusNotPrinted',
    'accountBadgeDistributionStatusProcessing',
    'accountBadgeDistributionStatusPrinted',
    'accountBadgeDistributionStatusDistributed',
];
export const distributionStatusHistoryActionMap = {
    'not-printed': 'accountBadgeDistributionStatusNotPrinted',
    processing: 'accountBadgeDistributionStatusProcessing',
    printed: 'accountBadgeDistributionStatusPrinted',
    distributed: 'accountBadgeDistributionStatusDistributed',
};
export const badgeHistoryEntityName = 'badgeHistory';
export const badgeHistorySchema = z.object({
    badgeId: z.string().uuid(),
    action: z.enum(badgeHistoryActions),
    note: z.string().max(zodKnownFieldDefaultValidation.stringMax).optional(),
    createdAt: z.number().optional(),
    createdByEmail: z.string().email().optional(),
    createdByRole: z.string().optional(),
    accountBadgeIds: z.string().uuid().array(),
    accountBadgeNames: z.string().array().optional(),
});
export const badgeHistoryColumns = defineColumns({
    badgeId: { type: 'foreign-key', entity: 'badge', index: true },
    action: { type: 'string-required', index: true },
    note: { type: 'string', index: 'partial' },
    createdAt: { type: 'number-required', index: true },
    createdByEmail: { type: 'string-required' },
    createdByRole: { type: 'string-required' },
    accountBadgeIds: { type: 'string-array-required' },
    accountBadgeNames: { type: 'string-array-required' },
    search: { type: 'string-required', index: 'partial' },
});
